import script from "./TransferReceivePage.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferReceivePage.vue?vue&type=script&setup=true&lang=js"

import "./TransferReceivePage.vue?vue&type=style&index=0&id=2940628f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2940628f"]])

export default __exports__